import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import GHref from 'tennders-market/common/components/element/GHref'
import GRoute from 'tennders-common/form/components/GRoute'
import IconAddFilled from '../../../../icons/icon-add-filled.svg'

const PickupLocation = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    pickupStops,
    removePickupStop,
    getMinPickupDate,
    setPickupStops,
    addPickupStop
  } = props

  return (
    <>
      <h3 className="bold">{t('document:pickUp')}</h3>
      <GRoute
        forDocument
        orderGenerateDoc
        errors={errors?.pickupRoute}
        title={`1. ${t('document:pickupLocation')}`}
        route={form.pickupRoute}
        isAllRequired
        onChange={(location, childKey) => onChange('pickupRoute', location, childKey)}
      />
      {
        pickupStops.map((location, index) => (
          <GRoute
            orderGenerateDoc
            forDocument
            errors={errors[`pickupStops[${index}]`]}
            removeStop={removePickupStop}
            hasRemoveStop
            title={`${index + 2}. ${t('document:pickupLocation')}`}
            minDate={getMinPickupDate(index)}
            maxDate={form.deliveryRoute && form.deliveryRoute.date && form.deliveryRoute.date[0]}
            key={location.identifier}
            route={pickupStops[index]}
            onChange={(location) => {
              const stops = [...pickupStops]
              stops[index] = { ...location }
              setPickupStops(stops)
            }}
          />
        ))
      }
      <GHref className="d-flex align-center mt-16 mr-32 btn-link" onClick={addPickupStop}>
        <IconAddFilled className="btn-only-icon" />
        {t('document:addAnotherPickupStop')}
      </GHref>
    </>
  )
}

export default React.memo(PickupLocation)
